module.exports = __webpack_public_path__ + "static/media/Assets-07-Camden-Market-02.b0d223d2.png";